module.exports = require("./nd.d.ts");